module.exports = __webpack_public_path__ + "img/H2.786a83b2.png";